'use client';
import React from 'react';
import { Link } from 'react-router-dom';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/autoplay';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

// Import project images
import testimonialImg1 from '../../assets/images/testimonial/amit.png';
import testimonialImg2 from '../../assets/images/testimonial/aman.png';
import testimonialImg3 from '../../assets/images/testimonial/neha.png';
import testimonialRightImg from '../../assets/images/testimonial/testimonial-two-img-1.jpg'; // Right side image

export const testimonials = [
  {
    imgSrc: testimonialImg1,
    name: 'Amit Khanna',
    company: 'Khanna Metal Works',
    text: 'Ramana Steel has been our trusted supplier for hydraulic scrap balers and scrap magnets. Their equipment is top-notch, ensuring efficiency in our scrap processing. Highly recommended for quality and reliability!',
  },
  {
    imgSrc: testimonialImg2,
    name: 'Simranjit Singh',
    company: 'Punjab Iron & Steel Works',
    text: 'Ramana Steel’s Vertical Heavy Duty Scrap Shear is a game-changer. It delivers high precision and efficiency, allowing us to process heavy scrap effortlessly. Excellent after-sales service and technical support!',
  },
  {
    imgSrc: testimonialImg3,
    name: 'Neha Chopra',
    company: 'Chopra Industries',
    text: 'Ramana Steel’s Movable Excavator and Scrap Grabber have been game-changers for our operations. Their products are durable, efficient, and backed by great customer service. Would highly recommend them to anyone in the industry!',
  },
];

// Testimonials data
// export const testimonials = [
//   {
//     imgSrc: testimonialImg1,
//     name: 'James Anderson',
//     company: 'Roof Masters',
//     text: 'Roof Service is a category that encompasses a range of services related to roofs. These services include roof installation, repair, maintenance, and inspection. Roofing experts provide solutions for various types of roofs, such as shingle.',
//   },
//   {
//     imgSrc: testimonialImg2,
//     name: 'Robert Son',
//     company: 'Roof Masters',
//     text: 'Roof Service is a category that encompasses a range of services related to roofs. These services include roof installation, repair, maintenance, and inspection. Roofing experts provide solutions for various types of roofs, such as shingle.',
//   },
//   {
//     imgSrc: testimonialImg3,
//     name: 'Adam Smith',
//     company: 'Roof Masters',
//     text: 'Roof Service is a category that encompasses a range of services related to roofs. These services include roof installation, repair, maintenance, and inspection. Roofing experts provide solutions for various types of roofs, such as shingle.',
//   },
// ];

// Swiper options
const swiperOptions = {
  modules: [Autoplay, Pagination, Navigation],
  slidesPerView: 3,
  spaceBetween: 30,
  speed: 2000,
  autoplay: {
    delay: 9000,
    disableOnInteraction: false,
  },
  loop: true,
  navigation: {
    nextEl: '.swiper-button-next1',
    prevEl: '.swiper-button-prev1',
  },
  pagination: {
    el: '.swiper-dot-style1',
    type: 'bullets',
    clickable: true,
  },
  breakpoints: {
    0: {
      spaceBetween: 0,
      slidesPerView: 1,
    },
    375: {
      spaceBetween: 0,
      slidesPerView: 1,
    },
    575: {
      spaceBetween: 0,
      slidesPerView: 1,
    },
    768: {
      spaceBetween: 30,
      slidesPerView: 1,
    },
    992: {
      spaceBetween: 30,
      slidesPerView: 2,
    },
    1200: {
      spaceBetween: 30,
      slidesPerView: 2,
    },
    1320: {
      spaceBetween: 30,
      slidesPerView: 3,
    },
  },
};

export default function TestimonialTwo() {
  return (
    <>
      {/* Testimonial Two Start */}
      <section className="testimonial-two">
        <div className="container">
          <div className="section-title-for-testimonial text-center">
            <div className="section-title__tagline-box">
              <span className="section-title__tagline">Clients testimonial</span>
            </div>
            <h2 className="section-title__title">
              Experience Shared,<br /><span> Trust Earned!</span>
            </h2>
          </div>
          <div className="row">
            <div className="col-xl-12 col-lg-12 ">
              <div className="testimonial-two__left ">
                <Swiper {...swiperOptions}>
                  {testimonials.map((testimonial, index) => (
                    <SwiperSlide key={index}>
                      <div className="testimonial-two__single shadow p-3 mb-3 bg-gray">
                        <div className="testimonial-two__quote">
                          <span className="icon-quote"></span>
                        </div>
                        <div className="testimonial-two__client-info">
                          <div className="testimonial-two__client-img">
                            <img src={testimonial.imgSrc} alt={testimonial.name} />
                          </div>
                          <div className="testimonial-two__client-content">
                            <h3><Link to="/testimonials">{testimonial.name}</Link></h3>
                            <p>{testimonial.company}</p>
                          </div>
                        </div>
                        <p className="testimonial-two__text">
                          {testimonial.text}
                        </p>
                        <div className="testimonial-two__ratting">
                          <span className="icon-star"></span>
                          <span className="icon-star"></span>
                          <span className="icon-star"></span>
                          <span className="icon-star "></span>
                          <span className="icon-star "></span>
                        </div>
                      </div>
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
            </div>
            {/* <div className="col-xl-6 col-lg-6">
              <div className="testimonial-two__right">
                <div className="testimonial-two__img">
                  <img
                    src={testimonialRightImg} // Using imported image for the right side
                    alt="Testimonial img"
                  />
                </div>
              </div>
            </div> */}
          </div>
        </div>
      </section>
      {/* Testimonial Two End */}
    </>
  );
}
